import z from 'zod';

import { EAdminRole } from '@enums/admin.enum';
import { paginationSchema } from '@schemas/pagination.schema';

export const getAllAdminsSchema = paginationSchema.extend({
  archived: z.boolean().optional(),
  roles: z.enum(EAdminRole).array().optional(),
  search: z.string().trim().optional(),
});

export type GetAllAdminsParams = z.infer<typeof getAllAdminsSchema>;
